<template>
  <div class="shopInfo" v-loading="loading" element-loading-text="开通中">
    <div class="relative">
      <div class="link link-one absolute"></div>
      <!-- <div class="link link-two absolute"></div> -->
      <el-form ref="form" :model="form" :rules="rules" label-width="93px">
        <div class="form-step fb mar10-b f16"><span class="mar20-r white f12">1</span> {{ orgName }}</div>
        <div class="flex mar50-l" style="height: 40px">
          <span v-if="state != 8"
            >企业暂未绑定收款账户，暂不支持线上支付,您可以现在
            <el-button size="mini" type="primary" @click="toAuth()">去绑定</el-button>
            也可开通店铺后进行绑定
          </span>
        </div>
        <div class="form-step fb mar20-b f16"><span class="mar20-r white f12">2</span> 经营信息</div>
        <div class="mar50-l">
          <el-form-item label="店铺名称：" prop="name">
            <el-input class="w520" v-model="form.name" placeholder="请填写名称"></el-input>
          </el-form-item>
          <el-form-item label="经营类目：" prop="type">
            <el-checkbox-group v-model="type">
              <el-checkbox label="1" name="农资"> {{ "农资" }}</el-checkbox>
              <el-checkbox label="2" name="农牧"> {{ "农牧" }}</el-checkbox>
              <el-checkbox label="3" name="水产品"> {{ "水产品" }}</el-checkbox>
              <el-checkbox label="4" name="农产品"> {{ "农产品" }}</el-checkbox>
              <el-checkbox label="5" name="禽蛋"> {{ "禽蛋" }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="所在地：" class="addr-select">
            <el-select v-model="indProvince" placeholder="请选择省/市" @change="provinceChange(1)">
              <el-option v-for="item in province" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-select v-model="indCity" placeholder="请选择市/县" @change="cityChange(1)">
              <el-option v-for="item in city" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-select v-model="indCountry" placeholder="请选择县" @change="countryChange(1)">
              <el-option v-for="item in country" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-select v-model="indTownship" placeholder="请选择乡镇" @change="townshipChange(1)">
              <el-option v-for="item in township" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址：" prop="address">
            <el-input class="w520" v-model="form.addr" placeholder="请填写详细地址"></el-input>
            <!--<el-button type="text" @click="checkAmap">选择</el-button>-->
          </el-form-item>
          <el-button type="primary" :disabled="!checked" @click="onSubmitOpen()">立即开通</el-button>
        </div>
        <el-checkbox v-model="checked" class="agreement">
          阅读并同意
          <a href="JavaScript:;" @click="readAgreement"> 《农信用户注册协议》 </a>
        </el-checkbox>
      </el-form>
    </div>
    <!--平台协议-->
    <agreement :visible.sync="readAgreementVisible"></agreement>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>
<style>
.shopInfoMag .el-message-box__headerbtn:focus .el-message-box__close,
.shopInfoMag .el-message-box__headerbtn:hover .el-message-box__close {
  color: #909399;
}
.shopInfoMag .el-button--default:hover,
.shopInfoMag.el-button--default:focus {
  background: #ffffff;
  border: 1px solid #dcdfe6;
  color: #606266;
}
.shopInfoMag .el-button--primary,
.shopInfoMag .el-button--primary:hover,
.shopInfoMag.el-button--primary:focus {
  background-color: #0095f1;
  border-color: #0095f1;
  color: #fff;
}
</style>
<script>
import agreement from "@/components/Agreement";

export default {
  components: {
    agreement,
  },
  data() {
    return {
      shopType: "ORDER_GOODS", // 开通的订到店铺类型  MICRO_STORE -- 微店  ORDER_GOODS -- 订货
      isSuccess: false,
      form: {
        name: "",
        addr: "",
        areaId: "",
        areaAxis: "",
        areaName: "",
        audit: "1",
        shopSort: "",
        identityType: "3",
        shopBusinessType: 0,
        shopBusinessTypes: "",
        orgBoId: null,
        boId: null,
        qualificationStatus: 0,
      },
      type: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入店铺名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "名称过长，请重新输入",
            trigger: "blur",
          },
        ],
        addr: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "详细地址过长，请重新输入",
            trigger: "blur",
          },
        ],
      },
      province: [],
      city: [],
      country: [],
      township: [],
      indProvince: "",
      indProName: "",
      indCity: "",
      indCityName: "",
      indCountry: "",
      indCountryName: "",
      indTownship: "",
      indTownshipName: "",
      orgBoId: "",
      isSubmit: true,
      orgName: "",
      state: null,
      loading: false,
      readAgreementVisible: false,
      checked: false,
      readAgreementFlag: false,
    };
  },
  created() {
    if (/(nxin.com)$/.test(window.location.host)) {
      document.domain = "nxin.com";
    }
    if (/(dbn.cn)$/.test(window.location.host)) {
      document.domain = "dbn.cn";
    }
    this.$store
      .dispatch("app/getAreas", {
        parentId: 0,
      })
      .then((data) => {
        this.province = data || [];
      });
    this.$store.dispatch("shop/shop/getEnterpriseByBoId").then((res) => {
      if (res.data && res.data.Type === 0) {
        this.$store
          .dispatch("shop/shop/getEnterpriseByDetail", {
            id: res.data.ID,
          })
          .then((resA) => {
            this.orgName = resA.data.name;
            this.state = resA.data.state; //认证状态,8为已经认证,1为认证被驳回,0为审核中,2:未提交审核
            this.form.name = resA.data.name;
            this.form.addr = resA.data.address;
            this.indProvince = resA.data.province !== 0 ? Number(resA.data.province) : "";
            this.indCity = resA.data.city !== 0 ? Number(resA.data.city) : "";
            this.indCountry = resA.data.country !== 0 ? Number(resA.data.country) : "";
            this.provinceChange(0);
          });
      } else {
        this.$message.error("请切换或注册企业(个体工商)身份后，提交入驻申请！");
      }
    });
  },
  methods: {
    onSubmitOpen() {
      if (!this.checked || !this.readAgreementFlag) {
        this.$message.error("请查看协议内容！");
        return;
      }
      this.$set(this.form, "isOpenApplication", "0");
      if (this.form.name === "") {
        this.$message.error("请输入店铺名称");
        return;
      }
      this.form.shopSort = this.shopType;
      let idNum = 0;
      this.form.shopBusinessType = 0;
      this.form.shopBusinessTypes = "";
      this.type.forEach((e) => {
        this.form.shopBusinessTypes += `${Number(e)},`;
        this.form.shopBusinessType += Math.pow(2, Number(e) - 1);//eslint-disable-line
        idNum += 1;
      });
      if (idNum === 0) {
        this.$message.error("请选择经营类目！");
        return;
      }
      const number = this.form.shopBusinessTypes.lastIndexOf(",");
      this.form.shopBusinessTypes = this.form.shopBusinessTypes.substring(0, number);
      this.form.audit = "1";
      this.form.qualificationStatus = 1;
      if (this.form.areaId === "") {
        this.$message.error("请选择地区！");
        return;
      }
      if (this.form.addr === "") {
        this.$message.error("请填写详细地址！");
        return;
      }
      this.$confirm("确定要开通系统？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "shopInfoMag",
      }).then(() => {
        this.$set(this.form, "isOpenApplication", "1");
        // 调接口
        this.loading = true;
        this.$store
          .dispatch("shop/shop/getShopApply", this.form)
          .then((res) => {
            if (res.code === "0") {
              // this.isSuccess = true;
              // type: "warning",
              this.$alert("开通成功", "提示", {
                confirmButtonText: "确定",
                customClass: "shopInfoMag",
                showCancelButton: false,
                showClose: false,
              }).then(() => {
                window.top.postMessage({ fn: "close", data: { url: `${process.env.VUE_APP_APP}v/orderSystem/dhShop` } }, "*");
                window.parent.postMessage(
                  {
                    fn: "reload",
                  },
                  "*"
                );
                // window.location.href = `${process.env.VUE_APP_APP}v/mj/managegoods?appid=1&isShowTitle=1`;
              });
            } else {
              this.$message.error(res.msg);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    // 选择省份
    provinceChange(isReset) {
      this.city = [];
      this.province.forEach((item) => {
        if (item.id === this.indProvince) {
          this.indProName = item.name;
        }
      });
      this.$store
        .dispatch("app/getAreas", {
          parentId: this.indProvince,
        })
        .then((data) => {
          this.city = data || [];
          if (isReset === 1) this.indCity = data.length ? data[0].id : "";
          this.cityChange(isReset);
        });
    },
    readAgreement() {
      this.readAgreementVisible = true;
      this.readAgreementFlag = true;
    },
    // 选择市
    cityChange(isReset = 1) {
      this.country = [];
      this.city.forEach((item) => {
        if (item.id === this.indCity) {
          this.indCityName = item.name;
        }
      });
      this.$store
        .dispatch("app/getAreas", {
          parentId: this.indCity,
        })
        .then((data) => {
          this.country = data || [];
          if (isReset === 1) this.indCountry = data.length ? data[0].id : "";
          this.countryChange(isReset);
        });
    },
    // 选择县区
    countryChange(isReset = 1) {
      this.township = [];
      this.country.forEach((item) => {
        if (item.id === this.indCountry) {
          this.indCountryName = item.name;
        }
      });
      this.form.areaId = this.indCountry;
      this.form.areaAxis = `$${this.indProvince}$${this.indCity}$${this.indCountry}`;
      this.form.areaName = this.indProName + this.indCityName + this.indCountryName;
      this.$store
        .dispatch("app/getAreas", {
          parentId: this.indCountry,
        })
        .then((data) => {
          this.township = data || [];
          if (isReset === 1) this.indTownship = data.length ? data[0].id : "";
          this.townshipChange();
        });
    },
    // 选择街道
    townshipChange() {
      this.township.forEach((item) => {
        if (item.id === this.indTownship) {
          this.indTownshipName = item.name;
        }
      });
      this.form.areaId = this.indTownship;
      this.form.areaAxis = `$${this.indProvince}$${this.indCity}$${this.indCountry}$${this.indTownship}`;
      this.form.areaName = this.indProName + this.indCityName + this.indCountryName + this.indTownshipName;
    },
    toAuth() {
      window.location.href = `${process.env.VUE_APP_JR}v/accountAsset/balance/open`;
    },
  },
};
</script>
